import LinkButton from 'components/shared/button/LinkButton';
import GNESingleSelect from 'components/shared/dropdown/GNESingleSelect';
import GNEModal from 'components/shared/modal/Modal';
import { addNewUserView } from 'components/shared/views/services/user-view.service';
import { VIEW_CATEGORY, INSIGHT_TYPE_CODE } from 'constants/constants';
import { useState } from 'react';
import { Button, Col, Form, Row, Tab, Tabs } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { setAllMView } from 'store/home/homeMyViewSlice';
import { formatViewOwnerOptionLabel } from 'utils/utils';
import { viewNameValidation } from 'utils/utils';

const AddTileModal = ({ show, onHide, onAddToMyView }) => {
  const [title, setTitle] = useState('');
  const [titleError, setTitleError] = useState('');
  const [selectedView, setSelectedView] = useState(null);
  const allMViews = useSelector((state) => state?.HomeMyView.allMViews);
  const [activeTab, setActiveTab] = useState(
    allMViews.length === 0 ? 'addView' : 'myView'
  );

  const dispatch = useDispatch();

  const { unixId, roleId } = useSelector(
    (state) => state?.Auth?.userClaimObject
  );

  const onViewSelection = (selected) => {
    setSelectedView(selected);
  };

  const handleTitleChange = (e) => {
    const value = e.target.value;
    const view = viewNameValidation(value);
    setTitle(view?.name);
    setTitleError(view?.errMsg);
  };

  const onCancel = (e) => {
    onHide(false);
    setTitle('');
    setTitleError('');
  };

  const onSave = async () => {
    if (activeTab === 'addView') {
      const payload = {
        unixId: unixId,
        roleId: roleId,
        name: title,
        type: INSIGHT_TYPE_CODE.GENERAL,
        owner: 'Me',
        category: VIEW_CATEGORY.CREATED,
      };
      const response = await addNewUserView(payload);
      if (response.result.Id) {
        dispatch(setAllMView([response?.result, ...allMViews]));
        onAddToMyView(response.result.Id, 0);
      }
    } else {
      onAddToMyView(selectedView?.Id, 0);
    }
  };

  const options = allMViews?.map((item) => {
    return { ...item, value: item?.name, label: item?.name };
  });

  const onChangeTabHandler = (k) => {
    setActiveTab(k);
    setTitle('');
    setSelectedView(null);
  };

  const content = (
    <div>
      <Row>
        <Col
          className='d-flex align-items-center mb-1'
          sm={12}>
          <i className='icon icon__addTitle lg me-2' />
          <span className='text text__text-medium text__bold'>
            Add to My View
          </span>
        </Col>
        <Col sm={12}>
          <p className='text text__text-small'>
            Please select a view or create a new view to add this tile into.
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <Tabs
            activeKey={activeTab}
            onSelect={onChangeTabHandler}
            unmountOnExit={true}
            mountOnEnter={true}
            className={`mb-3 ps-0 `}>
            <Tab
              disabled={allMViews.length === 0}
              eventKey='myView'
              title={<span className='d-flex'>My Views</span>}>
              <div className={`w-100 mt-4 mb-5 me-2 `}>
                <GNESingleSelect
                  value={selectedView}
                  placeholder='Select View'
                  onChange={onViewSelection}
                  options={options}
                  className={`single-select`}
                  formatOptionLabel={(data, { context }) =>
                    formatViewOwnerOptionLabel(
                      { ...data, isInsights: false },
                      { context }
                    )
                  }
                />
              </div>
            </Tab>
            <Tab
              eventKey='addView'
              title={<span className='d-flex'>Add New View</span>}>
              <div>
                <Form.Group
                  as={Col}
                  controlId='validationCustom01'>
                  <Form.Label className='text text__small'>Title</Form.Label>
                  <Form.Control
                    required
                    type='text'
                    value={title}
                    onChange={handleTitleChange}
                    autoComplete='off'
                    isInvalid={titleError?.length > 0}
                    isValid={title?.length > 0 && titleError?.length === 0}
                    maxLength={129}
                  />
                  <Form.Control.Feedback
                    className='animate__animated animate__pulse w-100'
                    type='invalid'>
                    <div className='d-flex justify-content-between'>
                      <span>{titleError}</span>{' '}
                      <span>{title?.length} / 128 </span>
                    </div>
                  </Form.Control.Feedback>
                </Form.Group>
                {!titleError && (
                  <span className=' w-100 d-flex justify-content-end'>
                    {title?.length} / 128
                  </span>
                )}
              </div>
            </Tab>
          </Tabs>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className='d-flex justify-content-end mt-4 mb-2'>
            <LinkButton
              onClick={onCancel}
              className='text text__small  me-2'>
              Cancel
            </LinkButton>
            <Button
              onClick={onSave}
              variant='btn btn-gne btn-primary'
              type='submit'
              disabled={
                activeTab === 'addView'
                  ? !title?.length || titleError?.length > 0
                  : selectedView?.Id === undefined
              }>
              Save
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
  return (
    <>
      <GNEModal
        show={show}
        onHide={onHide}
        content={content}
        css='size-medium'
        backdrop='static'
      />
    </>
  );
};
export default AddTileModal;
